<div class="container">
  <div class="row">
    <div class="login-cont mx-auto">
      <div class="card login-form">
        <div class="card-header">Two-Factor Authentication</div>
        <div class="card-body">
          <div>
            <p>
              Hello CODE Team, in our outgoing commitment to safety and security, we are introducing Two-Factor Authentication (2FA). Activation will be mandatory before being able to proceed to the CMS.
            </p>
            <p>
              To activate it, follow these steps:
            </p>
              <ol>
                <li>
                  Click the button below to enable 2FA for your account and generate a QR code.
                  <br />
                  <div
                    style='display: flex; align-items: center;'
                    [class.done]='qrCode'
                    class='mt-4'
                  >
                    <button
                      type='button'
                      class='btn btn-success'
                      (click)='enable2fa()'
                      [disabled]='loading || qrCode'
                    >
                      Enable 2FA
                    </button>
                  </div>
                  <img *ngIf='qrCode' [src]="qrCode" class='mt-4'>
                </li>
                <li class='mt-4'>
                  Download an authenticator app to your mobile phone. Our recommendation is Google Authenticator. If you have an existing authenticator app, you may use it instead.
                </li>
                <li class='mt-4'>
                  Open the authenticator app, click ‘Add’ and scan the QR code above to complete the 2FA setup.
                </li>
              </ol>
          </div>
          <button
            class="btn btn-primary mt-4 pull-right"
            [disabled]="loading || !qrCode"
            (click)='continue()'
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/auth/totp/totp.component.html